export interface Question {
  id: number;
  section: string;
  question: string;
  options: string[];
  answer: number; // 0-based index of correct option
}

// 20 questions × 5 marks = 100 marks total.  Pass mark: 14/20 correct (70 marks).
export const module1Questions: Question[] = [
  // ── Section A: Understanding the Accountant Role ──────────────────────────
  {
    id: 1,
    section: 'Section A: Understanding the Accountant Role',
    question: 'What is the main role of an Accountant?',
    options: [
      'A. Repair cars',
      'B. Record and manage financial transactions for clients',
      'C. Build houses',
      'D. Sell land',
    ],
    answer: 1, // B
  },
  {
    id: 2,
    section: 'Section A: Understanding the Accountant Role',
    question: 'A freelance accountant usually works:',
    options: [
      'A. Only in a hospital',
      'B. Remotely using accounting software and internet tools',
      'C. Only in a classroom',
      'D. Only at night',
    ],
    answer: 1, // B
  },
  {
    id: 3,
    section: 'Section A: Understanding the Accountant Role',
    question: 'Which of these is a common accounting task?',
    options: [
      'A. Bank reconciliation',
      'B. Driving buses',
      'C. Mining gold',
      'D. Surgery',
    ],
    answer: 0, // A
  },
  {
    id: 4,
    section: 'Section A: Understanding the Accountant Role',
    question: 'An accountant helps clients manage:',
    options: [
      'A. Noise',
      'B. Financial records and reports',
      'C. Rain',
      'D. Fuel only',
    ],
    answer: 1, // B
  },
  {
    id: 5,
    section: 'Section A: Understanding the Accountant Role',
    question: 'Which skill is most important for an accountant?',
    options: [
      'A. Laziness',
      'B. Attention to detail and numerical accuracy',
      'C. Fighting',
      'D. Gossip',
    ],
    answer: 1, // B
  },

  // ── Section B: Communication & Professionalism ────────────────────
  {
    id: 6,
    section: 'Section B: Communication & Professionalism',
    question: 'If a client sends financial documents, you should:',
    options: [
      'A. Ignore them',
      'B. Review carefully and confirm receipt',
      'C. Delete them',
      'D. Reply next month',
    ],
    answer: 1, // B
  },
  {
    id: 7,
    section: 'Section B: Communication & Professionalism',
    question: "If you don't understand a financial requirement:",
    options: [
      'A. Guess',
      'B. Ask clear clarifying questions',
      'C. Complain online',
      'D. Block client',
    ],
    answer: 1, // B
  },
  {
    id: 8,
    section: 'Section B: Communication & Professionalism',
    question: 'Best tone when replying to a client about their accounts:',
    options: [
      'A. Rude',
      'B. Professional and clear',
      'C. Angry',
      'D. Silent',
    ],
    answer: 1, // B
  },
  {
    id: 9,
    section: 'Section B: Communication & Professionalism',
    question: 'What builds client trust most as an accountant?',
    options: [
      'A. Excuses',
      'B. Accuracy, reliability, and timely reporting',
      'C. Fashion',
      'D. Arguments',
    ],
    answer: 1, // B
  },
  {
    id: 10,
    section: 'Section B: Communication & Professionalism',
    question: 'Missing financial report deadlines often can:',
    options: [
      'A. Increase trust',
      'B. Harm your reputation and affect client compliance',
      'C. Raise salary automatically',
      'D. Do nothing',
    ],
    answer: 1, // B
  },

  // ── Section C: Tools & Productivity ──────────────────────────────
  {
    id: 11,
    section: 'Section C: Tools & Productivity',
    question: 'Which tool is commonly used for bookkeeping?',
    options: [
      'A. QuickBooks or Xero',
      'B. Spoon',
      'C. Pillow',
      'D. Mirror',
    ],
    answer: 0, // A
  },
  {
    id: 12,
    section: 'Section C: Tools & Productivity',
    question: 'Which tool is best for payroll processing?',
    options: [
      'A. Sage Payroll',
      'B. Toaster',
      'C. Netflix',
      'D. Radio',
    ],
    answer: 0, // A
  },
  {
    id: 13,
    section: 'Section C: Tools & Productivity',
    question: 'Which tool is best for creating financial reports?',
    options: [
      'A. Excel or Google Sheets',
      'B. Hammer',
      'C. Flashlight',
      'D. Kettle',
    ],
    answer: 0, // A
  },
  {
    id: 14,
    section: 'Section C: Tools & Productivity',
    question: 'Why is data security important in accounting?',
    options: [
      'A. For decoration',
      'B. To protect sensitive client financial information',
      'C. For dancing',
      'D. For sleep',
    ],
    answer: 1, // B
  },
  {
    id: 15,
    section: 'Section C: Tools & Productivity',
    question: 'Cloud accounting software is important because:',
    options: [
      'A. It allows real-time access and collaboration',
      'B. It makes food sweeter',
      'C. It changes weather',
      'D. It grows hair',
    ],
    answer: 0, // A
  },

  // ── Section D: Business Growth & Earnings ────────────────────────
  {
    id: 16,
    section: 'Section D: Business Growth & Earnings',
    question: 'An accountant can increase their income by:',
    options: [
      'A. Gaining additional certifications and specialisations',
      'B. Ignoring clients',
      'C. Sleeping during deadlines',
      'D. Deleting work',
    ],
    answer: 0, // A
  },
  {
    id: 17,
    section: 'Section D: Business Growth & Earnings',
    question: 'Accounting rates may depend on:',
    options: [
      'A. Skill level, certifications, and complexity of work',
      'B. Height only',
      'C. Shoe colour',
      'D. Luck only',
    ],
    answer: 0, // A
  },
  {
    id: 18,
    section: 'Section D: Business Growth & Earnings',
    question: 'Repeat accounting clients usually come from:',
    options: [
      'A. Poor financial reports',
      'B. Accurate work and consistent communication',
      'C. Late submissions',
      'D. Arguments',
    ],
    answer: 1, // B
  },
  {
    id: 19,
    section: 'Section D: Business Growth & Earnings',
    question: 'An accounting portfolio helps by:',
    options: [
      'A. Showcasing past financial projects and client outcomes',
      'B. Hiding skills',
      'C. Causing confusion',
      'D. Reducing trust',
    ],
    answer: 0, // A
  },
  {
    id: 20,
    section: 'Section D: Business Growth & Earnings',
    question: 'Best mindset for a successful accounting professional:',
    options: [
      'A. Continuous learning and professional integrity',
      'B. Excuses',
      'C. Carelessness',
      'D. Delay',
    ],
    answer: 0, // A
  },
];

export {};
